import { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import ddt from '@wix/da-ddt';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { restrictLoggedOut } from '../../../redux/loggedout';
import { focusEditor } from '../../../CommentEditor/redux/actionCreators';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { generateReplyEditorId } from '../../utils';
import { CommentContext } from '../../CommentContext';
var getReplyToParam = function () {
    if (typeof window === 'undefined') {
        return;
    }
    // eslint-disable-next-line @wix/da/window-object-typeof-check
    if (!window.location.search) {
        return;
    }
    // eslint-disable-next-line @wix/da/window-object-typeof-check
    var params = new URLSearchParams(window.location.search);
    var replyTo = Number(params.get('reply_to'));
    return replyTo;
};
export function useReplyButtonBase(_a) {
    var _b = _a === void 0 ? {} : _a, onClick = _b.onClick, disabledOverride = _b.disabledOverride;
    var dispatch = useDispatch();
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var _c = useContext(CommentContext), comment = _c.comment, isReplying = _c.isReplying, setEditingState = _c.setEditingState, isReduxReady = _c.isReduxReady;
    var restrictToVerified = useVerification().restrictToVerified;
    var logBiEvent = useBiLogger();
    var handleClickInner = useCallback(function () {
        var _a;
        if (!isLoggedIn) {
            dispatch(restrictLoggedOut({ restrictedActionName: ReferralType.COMMENT }));
            return;
        }
        if (!isReplying) {
            // if arrived with reply_to param, we already logged this event in the trigger
            var withBiEvent = !getReplyToParam();
            if (withBiEvent) {
                logBiEvent({
                    evid: BiEventType.CLICK_REPLY_TO_COMMENT,
                    commenterid: (_a = comment.user) === null || _a === void 0 ? void 0 : _a.useridUuid,
                    commentid: comment.commentId,
                    typeid: comment.typeId,
                    itemid: comment.itemId,
                });
            }
        }
        ddt.log('comments', 'Replying on comment, editorId: ', generateReplyEditorId(comment));
        setEditingState(isReplying ? 'none' : 'replying');
        dispatch(focusEditor(generateReplyEditorId(comment)));
        onClick && onClick();
    }, [
        dispatch,
        logBiEvent,
        isReplying,
        isLoggedIn,
        setEditingState,
        comment,
        onClick,
    ]);
    var handleClick = restrictToVerified('comment', handleClickInner);
    return {
        /**
         * Handles all the necessary logic for opening a reply box under a comment.
         *
         * - Restriction to logged in users
         * - Restriction to verified users
         * - Logging
         * - Setting the correct state on the CommentContext to expand the reply comment box
         * - Focusing the editor after it's expanded
         */
        onClick: handleClick,
        /**
         * Returns `true` if redux isn't ready
         *
         * Can be overridden with the `disabledOverride` option
         */
        disabled: disabledOverride !== null && disabledOverride !== void 0 ? disabledOverride : !isReduxReady,
    };
}
//# sourceMappingURL=useReplyButtonBase.js.map